'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _withStyles = require('../with-styles');

var _withStyles2 = _interopRequireDefault(_withStyles);

var _styles = require('./styles');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Container = function Container(_ref) {
  var children = _ref.children,
      Tag = _ref.tag,
      classNames = _ref.classNames;

  if (!children) {
    return null;
  }

  return _react2.default.createElement(
    'div',
    { className: 'c11n-container-wrapper ' + classNames.outer },
    _react2.default.createElement(
      Tag,
      { className: 'c11n-container ' + classNames.root },
      children
    )
  );
};

Container.propTypes = {
  /**
   * The content
   */
  children: _propTypes2.default.any,

  /**
   * The tag or component to be used e.g. div, section
   */
  tag: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),

  /**
   * The max width of the container to be passed into our rhythm
   */
  width: _propTypes2.default.number,

  /**
   * The internal padding to be applied
   */
  spacing: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.number]),

  /**
   * Sets the min-height to the height of the viewport
   */
  fullHeight: _propTypes2.default.bool,

  /**
   * The shadow to be applies to the container
   */
  shadow: _propTypes2.default.string,

  /**
   * The background color of the container
   */
  background: _propTypes2.default.string,

  /**
   * The foreground color of the area
   */
  foreground: _propTypes2.default.string,

  /**
   * The color of the area outside the container
   */
  outerColor: _propTypes2.default.string,

  /**
   * The custom styles to be applied to the container
   */
  styles: _propTypes2.default.object
};

Container.defaultProps = {
  tag: 'article',
  spacing: 0,
  styles: {}
};

exports.default = (0, _withStyles2.default)(_styles2.default)(Container);


//////////////////
// WEBPACK FOOTER
// ../~/constructicon/container/index.js
// module id = 116
// module chunks = 0